import { render, staticRenderFns } from "./organicAcid.vue?vue&type=template&id=aa16e7e6&scoped=true&"
import script from "./organicAcid.vue?vue&type=script&lang=js&"
export * from "./organicAcid.vue?vue&type=script&lang=js&"
import style0 from "./organicAcid.vue?vue&type=style&index=0&id=aa16e7e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa16e7e6",
  null
  
)

export default component.exports